export const mandateStatus = {
    nurse: {
        "DEFAULT-édité": "Edité",
        "annulé": "Annulé",
        "accepté": "Accepté",
        "DEFAULT-refusé": "Refusé",
        "DEFAULT-attribué": "Demande de mandat"

    },
    doctor: {
        "DEFAULT-édité": "En attente coordination",
        "DEFAULT-refusé": "En attente validation",
        "annulé": "Annulé",
        "accepté": "Accepté",
        "DEFAULT-attribué": "En attente validation",
    },
    coordinator: {
        "DEFAULT-édité": "A coordonner",
        "annulé": "Annulé",
        "accepté": "Accepté",
        "DEFAULT-refusé": "Refusé",
        "DEFAULT-attribué": "Attribué"
    }
}